import PlayBtn from "../../assets/images/play-btn.png";

export const jiliGames = {
  PirateQueen: {
    code: "98567",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Pirate Queen",
    name: "Pirate Queen",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/Piratequeen.jpg",
    redirectUrl: "/casino/aggapjiligaming-pirate-queen",
    playImg: PlayBtn,
  },
  WildRacer: {
    code: "56768",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Wild Racer",
    name: "Wild Racer",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/Wildracer.jpg",
    redirectUrl: "/casino/aggapjiligaming-wild-racer",
    playImg: PlayBtn,
  },
  NekoFortune: {
    code: "98790",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Neko Fortune",
    name: "Neko Fortune",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/nekofortune.jpg",
    redirectUrl: "/casino/aggapjiligaming-neko-fortune",
    playImg: PlayBtn,
  },
  Samba: {
    code: "98789",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Samba",
    name: "Samba",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/samba.jpg",
    redirectUrl: "/casino/aggapjiligaming-samba",
    playImg: PlayBtn,
  },
  WorldCup: {
    code: "56968",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "World Cup",
    name: "World Cup",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/worldcup.jpg",
    redirectUrl: "/casino/aggapjiligaming-world-cup",
    playImg: PlayBtn,
  },
  BonusHunter: {
    code: "67660",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Bonus Hunter",
    name: "Bonus Hunter",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/bonushunter.jpg",
    redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
    playImg: PlayBtn,
  },
  JILICAISHEN: {
    code: "67580",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "JILI CAISHEN",
    name: "JILI CAISHEN",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/jilicaishen.jpg",
    redirectUrl: "/casino/aggapjiligaming-jili-caishen",
    playImg: PlayBtn,
  },
  MayanEmpire: {
    code: "67600",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Mayan Empire",
    name: "Mayan Empire",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/mayanempire.jpg",
    redirectUrl: "/casino/aggapjiligaming-mayan-empire",
    playImg: PlayBtn,
  },
  BoneFortune: {
    code: "87564",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Bone Fortune",
    name: "Bone Fortune",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/bonefortune.jpg",
    redirectUrl: "/casino/aggapjiligaming-bone-fortune",
    playImg: PlayBtn,
  },
  GoldRush: {
    code: "67620",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Gold Rush",
    name: "Gold Rush",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/goldrush.jpg",
    redirectUrl: "/casino/aggapjiligaming-gold-rush",
    playImg: PlayBtn,
  },
  HappyTaxi: {
    code: "67567",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Happy Taxi",
    name: "Happy Taxi",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/happytaxi.jpg",
    redirectUrl: "/casino/aggapjiligaming-happy-taxi",
    playImg: PlayBtn,
  },
  ThorX: {
    code: "67570",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Thor X",
    name: "Thor X",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/ThorX.jpg",
    redirectUrl: "/casino/aggapjiligaming-thor-x",
    playImg: PlayBtn,
  },
  BookofGold: {
    code: "56767",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Book of Gold",
    name: "Book of Gold",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/bookofgold.jpg",
    redirectUrl: "/casino/aggapjiligaming-book-of-gold",
    playImg: PlayBtn,
  },
  Medusa: {
    code: "98788",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Medusa",
    name: "Medusa",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/medusa.jpg",
    redirectUrl: "/casino/aggapjiligaming-medusa",
    playImg: PlayBtn,
  },
  GoGoalBingo: {
    code: "98791",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Go Goal Bingo",
    name: "Go Goal Bingo",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/gogoalbingo.jpg",
    redirectUrl: "/casino/aggapjiligaming-go-goal-bingo",
    playImg: PlayBtn,
  },
  ColorGame: {
    code: "67630",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Color Game",
    name: "Color Game",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/colorgame.jpg",
    redirectUrl: "/casino/aggapjiligaming-color-game",
    playImg: PlayBtn,
  },
  JackpotBingo: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Jackpot Bingo",
    name: "Jackpot Bingo",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/jackpotbingo.jpg",
    redirectUrl: "/casino/aggapjiligaming-jackpot-bingo",
    playImg: PlayBtn,
  },
  LuckyBingo: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Lucky Bingo",
    name: "Lucky Bingo",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/luckybingo.jpg",
    redirectUrl: "/casino/aggapjiligaming-lucky-bingo",
    playImg: PlayBtn,
  },
  WinDrop: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Win Drop",
    name: "Win Drop",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/windrop.jpg",
    redirectUrl: "/casino/aggapjiligaming-win-drop",
    playImg: PlayBtn,
  },
  FortuneBingo: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Fortune Bingo",
    name: "Fortune Bingo",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/fortunebingo.jpg",
    redirectUrl: "/casino/aggapjiligaming-fortune-bingo",
    playImg: PlayBtn,
  },
  Baccarat: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Baccarat",
    name: "Baccarat",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/baccarat.jpg",
    redirectUrl: "/casino/aggapjiligaming-baccarat",
    playImg: PlayBtn,
  },
  iRichBingo: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "iRich Bingo",
    name: "iRich Bingo",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/iRichBingo.jpg",
    redirectUrl: "/casino/aggapjiligaming-irich-bingo",
    playImg: PlayBtn,
  },
  DragonTiger: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Dragon & Tiger",
    name: "Dragon & Tiger",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/Dragon_tiger.jpg",
    redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
    playImg: PlayBtn,
  },
  BigSmall: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Big Small",
    name: "Big Small",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/Bigsmall.jpg",
    redirectUrl: "/casino/aggapjiligaming-big-small",
    playImg: PlayBtn,
  },
  GoldenJoker: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Golden Joker",
    name: "Golden Joker",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/goldenjoker.jpg",
    redirectUrl: "/casino/aggapjiligaming-golden-joker",
    playImg: PlayBtn,
  },
  MasterTiger: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Master Tiger",
    name: "Master Tiger",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/mastertiger.jpg",
    redirectUrl: "/casino/aggapjiligaming-master-tiger",
    playImg: PlayBtn,
  },
  WildAce: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Wild Ace",
    name: "Wild Ace",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/Wildace.jpg",
    redirectUrl: "/casino/aggapjiligaming-wild-ace",
    playImg: PlayBtn,
  },
  Crazy777: {
    code: "98566",
    casino: "aura",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    alt: "Crazy 777",
    name: "Crazy 777",
    providerName: "Jili Gaming",
    imgUrl: "./images/alt-gaming/jili-game/Crazy777.jpg",
    redirectUrl: "/casino/aggapjiligaming-crazy777",
    playImg: PlayBtn,
  },
};
